var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.campaign
    ? _c(
        "div",
        [
          _c("vx-card", { staticClass: "mb-4" }, [
            _c(
              "div",
              {
                staticClass: "flex justify-between items-start flex-wrap gap-2",
              },
              [
                _c("div", [
                  _c("h4", { staticClass: "mb-0" }, [
                    _vm._v(_vm._s(_vm.campaign.name)),
                  ]),
                  _c("small", { staticClass: "text-muted" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._.get(_vm.campaign, "legal_entity.name")) +
                        " · " +
                        _vm._s(_vm.windowLabel) +
                        " "
                    ),
                  ]),
                ]),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-2" },
                  [
                    _c(
                      "vs-chip",
                      {
                        staticClass: "text-base",
                        attrs: { transparent: "", color: _vm.statusColor },
                      },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t("campaign.status_." + _vm.campaign.status)
                            ) +
                            " "
                        ),
                      ]
                    ),
                    _vm.campaign.status === "PA"
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.approve",
                                expression: "'campaigns.approve'",
                              },
                            ],
                            attrs: { size: "sm", variant: "success" },
                            on: {
                              click: function ($event) {
                                return _vm.act("approve")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("campaign.accept")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.campaign.status === "PA"
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.approve",
                                expression: "'campaigns.approve'",
                              },
                            ],
                            attrs: { size: "sm", variant: "outline-danger" },
                            on: {
                              click: function ($event) {
                                return _vm.act("reject")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("campaign.refuse")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm.campaign.status === "AC"
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.pause",
                                expression: "'campaigns.pause'",
                              },
                            ],
                            attrs: { size: "sm", variant: "outline-warning" },
                            on: {
                              click: function ($event) {
                                return _vm.act("pause")
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$t("campaign.pause")) + " ")]
                        )
                      : _vm._e(),
                    _vm.campaign.status === "PU"
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.pause",
                                expression: "'campaigns.pause'",
                              },
                            ],
                            attrs: { size: "sm", variant: "outline-success" },
                            on: {
                              click: function ($event) {
                                return _vm.act("resume")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("campaign.resume")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                    !["CA", "EN"].includes(_vm.campaign.status)
                      ? _c(
                          "b-button",
                          {
                            directives: [
                              {
                                name: "permission",
                                rawName: "v-permission",
                                value: "campaigns.cancel",
                                expression: "'campaigns.cancel'",
                              },
                            ],
                            attrs: { size: "sm", variant: "outline-danger" },
                            on: {
                              click: function ($event) {
                                return _vm.act("cancel")
                              },
                            },
                          },
                          [
                            _vm._v(
                              " " + _vm._s(_vm.$t("campaign.cancel")) + " "
                            ),
                          ]
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            ),
            _c("div", { staticClass: "stats-row mt-3" }, [
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.discount"))),
                ]),
                _c("span", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.amountLabel(
                        _vm.campaign.discount_type,
                        _vm.campaign.discount_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.commission"))),
                ]),
                _c("span", { staticClass: "stat-value" }, [
                  _vm._v(
                    _vm._s(
                      _vm.amountLabel(
                        _vm.campaign.commission_type,
                        _vm.campaign.commission_amount
                      )
                    )
                  ),
                ]),
              ]),
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.budget"))),
                ]),
                _c(
                  "span",
                  { staticClass: "stat-value" },
                  [
                    _vm.campaign.budget_cap_cents
                      ? [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.money(_vm.campaign.budget_spent_cents)
                              ) +
                              " / " +
                              _vm._s(_vm.money(_vm.campaign.budget_cap_cents)) +
                              " "
                          ),
                        ]
                      : [_vm._v(_vm._s(_vm.$t("campaign.no_budget_cap")))],
                  ],
                  2
                ),
              ]),
              _c("div", { staticClass: "stat" }, [
                _c("span", { staticClass: "stat-label" }, [
                  _vm._v(_vm._s(_vm.$t("campaign.participants"))),
                ]),
                _c("span", { staticClass: "stat-value" }, [
                  _vm._v(_vm._s(_vm.activeParticipations.length)),
                ]),
              ]),
            ]),
          ]),
          _c(
            "b-tabs",
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: _vm.$t("campaign.tab_participations"),
                    active: "",
                  },
                },
                [
                  _c("vx-card", { staticClass: "mt-2" }, [
                    !(_vm.campaign.participations || []).length
                      ? _c("div", { staticClass: "text-muted" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$t("campaign.no_participants")) +
                              " "
                          ),
                        ])
                      : _c("table", { staticClass: "w-full detail-table" }, [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("influencer.name"))),
                              ]),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("campaign.coupon"))),
                              ]),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("campaign.link"))),
                              ]),
                              _c("th", [
                                _vm._v(_vm._s(_vm.$t("campaign.status"))),
                              ]),
                              _c("th"),
                            ]),
                          ]),
                          _c(
                            "tbody",
                            _vm._l(_vm.campaign.participations, function (p) {
                              return _c("tr", { key: p.id }, [
                                _c("td", [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._.get(p, "influencer.name")) +
                                      " "
                                  ),
                                  _c(
                                    "small",
                                    { staticClass: "text-muted d-block" },
                                    _vm._l(
                                      _vm._.get(
                                        p,
                                        "influencer.social_profiles",
                                        []
                                      ),
                                      function (s) {
                                        return _c(
                                          "span",
                                          { key: s.id, staticClass: "mr-1" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(s.network_label) +
                                                " @" +
                                                _vm._s(s.handle) +
                                                " "
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                                _c("td", [
                                  p.coupon_code
                                    ? _c("code", [
                                        _vm._v(_vm._s(p.coupon_code)),
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [_vm._v("—")]
                                      ),
                                ]),
                                _c("td", [
                                  p.tracking_slug
                                    ? _c("code", [
                                        _vm._v("/r/" + _vm._s(p.tracking_slug)),
                                      ])
                                    : _c(
                                        "span",
                                        { staticClass: "text-muted" },
                                        [_vm._v("—")]
                                      ),
                                ]),
                                _c(
                                  "td",
                                  [
                                    _c(
                                      "vs-chip",
                                      {
                                        attrs: {
                                          transparent: "",
                                          color: _vm.participationColor(
                                            p.status
                                          ),
                                        },
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t(
                                                "campaign.participation_status_." +
                                                  p.status
                                              )
                                            ) +
                                            " "
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "td",
                                  { staticClass: "text-right" },
                                  [
                                    p.status === "AP"
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value:
                                                  "campaign_participations.approve",
                                                expression:
                                                  "'campaign_participations.approve'",
                                              },
                                            ],
                                            staticClass: "mr-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "success",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.participationAct(
                                                  p,
                                                  "approve"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("influencer.approve")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    p.status === "AP"
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value:
                                                  "campaign_participations.approve",
                                                expression:
                                                  "'campaign_participations.approve'",
                                              },
                                            ],
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.participationAct(
                                                  p,
                                                  "reject"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("influencer.reject")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    p.status === "AC"
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value:
                                                  "campaign_participations.approve",
                                                expression:
                                                  "'campaign_participations.approve'",
                                              },
                                            ],
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-warning",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.participationAct(
                                                  p,
                                                  "pause"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("campaign.pause")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    p.status === "AC"
                                      ? _c(
                                          "b-button",
                                          {
                                            directives: [
                                              {
                                                name: "permission",
                                                rawName: "v-permission",
                                                value:
                                                  "campaign_participations.approve",
                                                expression:
                                                  "'campaign_participations.approve'",
                                              },
                                            ],
                                            staticClass: "ml-1",
                                            attrs: {
                                              size: "sm",
                                              variant: "outline-danger",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.participationAct(
                                                  p,
                                                  "block"
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$t("campaign.block")
                                                ) +
                                                " "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ])
                            }),
                            0
                          ),
                        ]),
                  ]),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("campaign.tab_briefing") } },
                [
                  _c("vx-card", { staticClass: "mt-2" }, [
                    _c("h5", [_vm._v(_vm._s(_vm.$t("campaign.briefing")))]),
                    _c("p", { staticClass: "text-muted" }, [
                      _vm._v(_vm._s(_vm.campaign.briefing || "—")),
                    ]),
                    _c("div", { staticClass: "vx-row" }, [
                      _c("div", { staticClass: "vx-col sm:w-1/2 w-full" }, [
                        _c("h6", { staticClass: "text-success" }, [
                          _vm._v(_vm._s(_vm.$t("campaign.dos"))),
                        ]),
                        _c("p", { staticClass: "text-muted small" }, [
                          _vm._v(_vm._s(_vm.campaign.dos || "—")),
                        ]),
                      ]),
                      _c("div", { staticClass: "vx-col sm:w-1/2 w-full" }, [
                        _c("h6", { staticClass: "text-danger" }, [
                          _vm._v(_vm._s(_vm.$t("campaign.donts"))),
                        ]),
                        _c("p", { staticClass: "text-muted small" }, [
                          _vm._v(_vm._s(_vm.campaign.donts || "—")),
                        ]),
                      ]),
                    ]),
                    _c(
                      "p",
                      { staticClass: "mb-0" },
                      [
                        _vm._l(_vm.campaign.hashtags || [], function (h) {
                          return _c(
                            "vs-chip",
                            {
                              key: h,
                              staticClass: "mr-1",
                              attrs: { transparent: "", color: "primary" },
                            },
                            [_vm._v(_vm._s(h))]
                          )
                        }),
                        _vm._l(_vm.campaign.mentions || [], function (m) {
                          return _c(
                            "vs-chip",
                            {
                              key: m,
                              staticClass: "mr-1",
                              attrs: { transparent: "", color: "success" },
                            },
                            [_vm._v(_vm._s(m))]
                          )
                        }),
                        _c(
                          "vs-chip",
                          { attrs: { transparent: "", color: "warning" } },
                          [_vm._v(_vm._s(_vm.campaign.disclosure_tag))]
                        ),
                      ],
                      2
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("campaign.tab_assets") } },
                [
                  _c("vx-card", { staticClass: "mt-2" }, [
                    !(_vm.campaign.assets || []).length
                      ? _c("div", { staticClass: "text-muted mb-2" }, [
                          _vm._v(_vm._s(_vm.$t("campaign.no_assets"))),
                        ])
                      : _c(
                          "table",
                          { staticClass: "w-full detail-table mb-2" },
                          [
                            _c(
                              "tbody",
                              _vm._l(_vm.campaign.assets, function (a) {
                                return _c("tr", { key: a.id }, [
                                  _c(
                                    "td",
                                    [
                                      _vm._v(" " + _vm._s(a.title) + " "),
                                      a.is_expired
                                        ? _c(
                                            "vs-chip",
                                            {
                                              staticClass: "ml-1",
                                              attrs: {
                                                transparent: "",
                                                color: "danger",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "campaign.asset_expired"
                                                  )
                                                )
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                      _c(
                                        "small",
                                        { staticClass: "text-muted d-block" },
                                        [_vm._v(_vm._s(a.usage_rights))]
                                      ),
                                    ],
                                    1
                                  ),
                                  _c("td", [
                                    a.external_url
                                      ? _c(
                                          "a",
                                          {
                                            attrs: {
                                              href: a.external_url,
                                              target: "_blank",
                                              rel: "noopener noreferrer",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.$t("campaign.open"))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                                  _c(
                                    "td",
                                    { staticClass: "text-right" },
                                    [
                                      _c("feather-icon", {
                                        directives: [
                                          {
                                            name: "permission",
                                            rawName: "v-permission",
                                            value: "campaigns.edit",
                                            expression: "'campaigns.edit'",
                                          },
                                        ],
                                        staticClass:
                                          "h-5 w-5 stroke-current text-danger cursor-pointer",
                                        attrs: { icon: "Trash2Icon" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeAsset(a)
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ])
                              }),
                              0
                            ),
                          ]
                        ),
                    _c(
                      "div",
                      {
                        directives: [
                          {
                            name: "permission",
                            rawName: "v-permission",
                            value: "campaigns.edit",
                            expression: "'campaigns.edit'",
                          },
                        ],
                        staticClass: "vx-row items-end",
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "vx-col sm:w-4/12 w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("campaign.asset_title"),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { type: "text" },
                                  model: {
                                    value: _vm.newAsset.title,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newAsset, "title", $$v)
                                    },
                                    expression: "newAsset.title",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "vx-col sm:w-2/12 w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: { label: _vm.$t("campaign.asset_kind") },
                              },
                              [
                                _c("b-form-select", {
                                  attrs: { options: _vm.assetKinds },
                                  model: {
                                    value: _vm.newAsset.kind,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newAsset, "kind", $$v)
                                    },
                                    expression: "newAsset.kind",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "vx-col sm:w-3/12 w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: { label: _vm.$t("campaign.asset_url") },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { type: "text" },
                                  model: {
                                    value: _vm.newAsset.external_url,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.newAsset,
                                        "external_url",
                                        $$v
                                      )
                                    },
                                    expression: "newAsset.external_url",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "vx-col sm:w-2/12 w-full" },
                          [
                            _c(
                              "b-form-group",
                              {
                                attrs: {
                                  label: _vm.$t("campaign.asset_expires"),
                                },
                              },
                              [
                                _c("b-form-input", {
                                  attrs: { type: "date" },
                                  model: {
                                    value: _vm.newAsset.expires_at,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.newAsset, "expires_at", $$v)
                                    },
                                    expression: "newAsset.expires_at",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "vx-col sm:w-1/12 w-full mb-1" },
                          [
                            _c(
                              "b-button",
                              {
                                attrs: { size: "sm", variant: "primary" },
                                on: { click: _vm.addAsset },
                              },
                              [
                                _c("feather-icon", {
                                  attrs: { icon: "PlusIcon" },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]
                    ),
                  ]),
                ],
                1
              ),
              _c(
                "b-tab",
                { attrs: { title: _vm.$t("campaign.tab_timeline") } },
                [
                  _c(
                    "vx-card",
                    { staticClass: "mt-2" },
                    _vm._l(_vm.campaign.events || [], function (e) {
                      return _c(
                        "div",
                        { key: e.id, staticClass: "timeline-row" },
                        [
                          _c("div", [
                            _c("strong", [_vm._v(_vm._s(e.event))]),
                            e.description
                              ? _c("span", { staticClass: "text-muted" }, [
                                  _vm._v(" — " + _vm._s(e.description)),
                                ])
                              : _vm._e(),
                          ]),
                          _c("small", { staticClass: "text-muted" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm._.get(e, "actor.name", "—")) +
                                " · " +
                                _vm._s(_vm.formatDateTime(e.created_at)) +
                                " "
                            ),
                          ]),
                        ]
                      )
                    }),
                    0
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-form-row",
            { staticClass: "justify-end mt-3" },
            [
              _c(
                "b-col",
                { attrs: { cols: "auto" } },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "outline-secondary" },
                      on: { click: _vm.goBack },
                    },
                    [
                      _c("feather-icon", {
                        staticClass: "mr-50",
                        attrs: { icon: "CornerUpLeftIcon" },
                      }),
                      _c("span", { staticClass: "align-middle" }, [
                        _vm._v(_vm._s(_vm.$t("back"))),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }